import useSWR from 'swr'

import { MeetingsAPI } from 'api/index'

const fetcher = (url: string) => MeetingsAPI.get(url).then((res) => res.data)

interface CalendarStatus {
  connected: boolean
  microsoftAuthed: boolean
  googleAuthed: boolean
  zoomAuthed: boolean
  tokenRevoked: boolean
  available: boolean
  agentId: number
  calendar?: {
    id: string
    name: string
    canEdit: boolean
  }
  integration: string
  tokenScopes: string[]
  microsoftClientId: string
  bulkCalendarEnabled: boolean
}

export default function useCalendarStatus() {
  return useSWR<CalendarStatus>('/calendar/properties/status/v3', fetcher)
}
